/* unplugin-vue-components disabled */import { render } from "./clockqr.vue?vue&type=template&id=6be984b2&scoped=true"
import script from "./clockqr.vue?vue&type=script&lang=js"
export * from "./clockqr.vue?vue&type=script&lang=js"

import "./clockqr.vue?vue&type=style&index=0&id=6be984b2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6be984b2"]])

export default __exports__